/* eslint-disable */
import { USER_SERVICE_PRESENCE_STATUS_PRESENT } from '../../Constants/User/User.constants';

/** @type {UserEntity} */
export const user1Fixture = {
  displayName: `John Doe`,
  email: `john.doe@boral.com.au`,
  id: `aaa`,
  initials: `JD`,
  login: `john.doe@boral.com.au`,
  password: `John123`,
  presence: USER_SERVICE_PRESENCE_STATUS_PRESENT,
  username: `john.doe`,
};

/** @type {UserEntity} */
export const user2Fixture = {
  displayName: `Jane Doe`,
  email: `jane.doe@boral.com.au`,
  id: `bbb`,
  initials: `JD`,
  login: `jane.doe@boral.com.au`,
  password: `Jane123`,
  presence: USER_SERVICE_PRESENCE_STATUS_PRESENT,
  username: `jane.doe`,
};

/** @type {Array<UserEntity>} */
export const usersFixture = [user1Fixture, user2Fixture];
